
export class ArtistDTO {
  constructor (key = '', name = '', image = '') {
    this.key = key;
    this.name = name;
    this.image = image;
  }
}
